import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DuplicatePassTemplateDialogComponent } from '../../duplicate-pass-template-dialog/duplicate-pass-template-dialog.component';
import { StorageService } from '../../service/storage.service';
import { getSizeBytes } from 'na-lib';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-media-preview-dialog',
    templateUrl: './media-preview-dialog.component.html',
    styleUrls: ['./media-preview-dialog.component.css'],
    standalone: false
})
export class MediaPreviewDialogComponent {
  mediaFileData:any
  mediaFile:any
  mediaFileName:string


  imagePreview: string | ArrayBuffer | null = null;
  videoPreview: string | ArrayBuffer | null = null;
  textPreview: string = '';
  pdfPreview: string | ArrayBuffer | null = null;
  pdfUrlSafe: SafeResourceUrl | null = null;

  constructor(
    public dialogRef: MatDialogRef<DuplicatePassTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private storageService:StorageService,
    private sanitizer: DomSanitizer
  ){dialogRef.disableClose = true;}


  ngOnInit(): void {
    if(this.data.data){
      const data = this.data.data
      this.mediaFileData = this.data
      this.mediaFile = data.folderItems   
      this.mediaFileName = data.folderItems.name 
    }else{
      this.mediaFileData = this.data
      this.mediaFile = this.data.file   
      this.mediaFileName = this.data.name 
    }
    this.loadFilePreview()  
  }

  getFileSize(size){
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    return getSizeBytes(size,units ,2)
  }
  
  downloadFile(){
    this.data.data.downloadFile(this.mediaFile)
  }

  deleteFile(){

    if(this.data.data){
      this.data.data.deleteFile(this.mediaFile)
      this.dialogRef.close([true, 'after-delete'])

    }else{ // TODO,delete this else
      this.storageService.deleteFile(this.mediaFile.reference).then( value => {
        
        this.dialogRef.close([true, 'after-delete'])
      })
    }

  }

  loadFilePreview() {
    this.mediaFile = this.mediaFileData.file;
    const ct = this.mediaFile?.metadata?.contentType || '';

    this.imagePreview = this.videoPreview = this.textPreview = null;
    this.pdfPreview = null;

    if (ct.startsWith('image/')) {
      this.imagePreview = this.mediaFileData.file.url;
      return;
    }
    if (ct.startsWith('video/')) {
      this.videoPreview = this.mediaFileData.file.url;
      return;
    }
    if (ct === 'text/plain') {
      this.textPreview = this.mediaFileData.file.url;
      return;
    }
    if (ct === 'application/pdf') {
      const raw = String(this.mediaFileData.file.url);
      const withParams = raw.includes('#') ? raw : `${raw}#view=FitH`;
      this.pdfUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(withParams);
    }
  }

  openFile(){
    window.open(this.mediaFileData.file.url.toString(), "_blank");
  }
}
